<template>
	<div class="about-bg">
		<van-row>
			<van-col span="24" class="about-icon-box">
				<van-image class="about-icon" src="../../../static/images/icon.png" />
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" class="about-info-box">
				<div class="fix about-line">
					<div class="fl">客服电话</div>
					<a class="fr about-phone" href="tel:010-56204616">010-56204616</a>
				</div>
				<div class="fix about-line">
					<div class="fl">E-mail</div>
					<div class="fr about-email">zhishen2015@126.com</div>
				</div>
				<div class="fix about-line">
					<div class="fl">用户协议</div>
					<van-image class="fr about-moreicon" src="../../../static/images/tiaozhuan.png" />
				</div>
				<div class="fix about-line">
					<div class="fl">服务条款</div>
					<van-image class="fr about-moreicon" src="../../../static/images/tiaozhuan.png" />
				</div>
			</van-col>
		</van-row>
	</div>
</template>

<script>
	export default{
		created(){
			document.title = "关于我们";
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
		}
	}
</script>

<style>
	@import url("../../assets/css/personal.css");
</style>



// WEBPACK FOOTER //
// src/view/personal/aboutus.vue